import React, { Component } from "react";
import "./Footer.css";


export default class Footer extends Component {

  render() {
      return (
        <footer id="footer" className="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row cols-xs-space cols-sm-space cols-md-space">
                        <div className="col-lg-3">

                        </div>

                        <div className="col-lg-6 text-center">
                            <div className="col">
                                <img src="/images/logo_retnetindia.png" alt="" />
                                <span className="clearfix"></span>
                                <p className="mt-3">
                                 Retina Specialists Network
                                </p>
                                <a href="" className="facebook" target="_blank" >
                                    <i className="fa fa-envelope"></i> <span className="whitefont"> &nbsp; retnetindia@gmail.com </span>
                                </a>
                                <div className="copyright mt-4">
                                    <p>
                                        Copyright © 2018                                <a href="/" target="_blank">
                                            <strong>Retnet India</strong>
                                        </a> -
                                        All rights reserved
                                    </p>
                                </div>
                            </div>
                        </div>



                        <div className="col-lg-3">

                        </div>
                    </div>
                </div>
            </div>
        </footer>
      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Footer.js